module.exports = __webpack_public_path__ + "media/images/brand/favicon-04-b48006e0ec17af445c77bb4f4295fe33.png";